import {Component, Inject} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {pwsInstallsType} from "../../interfaces";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";
import {Lib} from "../../../libs/Lib";
import {LocalStoreService} from "../../services";


@Component({
    selector: 'app-prompt',
    templateUrl: './pwa-prompt.component.html',
    styleUrls: ['./pwa-prompt.component.scss'],
    standalone: false
})
export class PwaPromptComponent {
    m_data;
    isChecked;

    constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: { mobileType: pwsInstallsType, promptEvent?: any },
                private localStoreService: LocalStoreService,
                private translocoService: TranslocoService,
                private toastr: ToastrService,
                private bottomSheetRef: MatBottomSheetRef<PwaPromptComponent>) {

        this.m_data = data;
        this.isChecked = this.localStoreService.getStorageValConfig('pwaHideInstaller') === '1';
    }

    public installPwa(): void {
        if (Lib.DevMode()) return alert('only supported in released mode');
        console.log('prompting pwa 1... ' + this.m_data);
        console.log('prompting pwa 2... ' + this.m_data.mobileType);
        if (!this.data.promptEvent) {
            this.toastr.info(this.translocoService.translate('general.pwsInstall1', {}, this.translocoService.getActiveLang()));
            this.close();
            return;
        }
        this.data.promptEvent.prompt();
        this.close();
    }

    public close() {
        this.bottomSheetRef.dismiss();
    }

    onChecked(e) {
        this.localStoreService.setStorageValConfig('pwaHideInstaller', String(e === true ? '1' : '0'));
        if (e === true) {
            this.close(); // Auto-close when user checks "don't show again"
        }
    }
}
